import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isProd, setFavicon } from "../../utils/AppUtils";
import { getLoginLogo, getLoginLogoClear } from "../../redux/home/actions";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";
import _ from "lodash";

const MenuChangePassword = () => {
  const navigate = useNavigate();
  const showChangePassword = useSelector((state) => state.home.showChangePassword);
  return (
    <>
      {showChangePassword === "true"? (
        <li>
          <button
            className="dropdown-item"
            type="button"
            onClick={() => {
              navigate("/change-password");
            }}
          >
            Change Password
          </button>
        </li>
      ) : (
        ""
      )}
    </>
  );
};
export default MenuChangePassword;
